// extracted by mini-css-extract-plugin
export default {"eventIndicator":"event-indicator__rcSptKm7","played":"played__jajSgiDA","observed":"observed__DmmyipBp"};